import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { itineraryToRouteIds } from '#/trip-planner/utils/routes';
import { itineraryIsCurrent } from '#/trip-planner/utils/date-time';
import useActiveItinerary from './useActiveItinerary';

export default () => {
  const [tripRouteIds, setTripRouteIds] = useState(null);
  const { transitiveData, itineraryBounds, focusedLegBounds } = useSelector(
    s => s.tripPlanner
  );

  const { activeItinerary } = useActiveItinerary();
  useEffect(() => {
    if (activeItinerary && itineraryIsCurrent(activeItinerary)) {
      setTripRouteIds(itineraryToRouteIds(activeItinerary));
    }
    return () => {
      setTripRouteIds(null);
    };
  }, [activeItinerary]);

  return { transitiveData, itineraryBounds, focusedLegBounds, tripRouteIds };
};
